export enum OR1P1Subsets {
  CLASS_ROSTERS_SUBSET = 'CLASS_ROSTERS',
  CLASS_ROSTERS_W_DEMOGRAPHICS_SUBSET = 'CLASS_ROSTERS_W_DEMOGRAPHICS',
  GRADEBOOK = 'GRADEBOOK',
  RESOURCES = 'RESOURCES',
}
